import axios from "axios";
import { getAdminSession } from "./adminAuth";

const ENV_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

export const CONTACT_US_API = `${ENV_API_BASE_URL}/api/contact-us`;
export const CONTACT_INQUIRIES_API = `${ENV_API_BASE_URL}/api/contact-inquiries`;

export const fetchContactUs = async () => {
  const res = await axios.get(CONTACT_US_API);
  return res.data?.data || null;
};

export const submitContactInquiry = async (payload) => {
  const res = await axios.post(CONTACT_INQUIRIES_API, payload);
  return res.data?.data;
};

const adminHeaders = () => {
  const session = getAdminSession();
  const token = session?.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const adminUpdateContactUs = async (payload) => {
  const res = await axios.put(CONTACT_US_API, payload, {
    headers: {
      "Content-Type": "application/json",
      ...adminHeaders(),
    },
  });
  return res.data?.data;
};

export const adminListInquiries = async ({ page = 1, limit = 50 } = {}) => {
  const res = await axios.get(CONTACT_INQUIRIES_API, {
    headers: adminHeaders(),
    params: { page, limit },
  });
  return res.data?.data;
};

